import useChoroplethSource from './useChoroplethSource';
import usePolygonLayer from './usePolygonLayer';
import {
	CHOROPLETH_COUNTRY_SOURCE,
	CHOROPLETH_STATE_SOURCE,
	SOURCE_LAYERS,
} from 'widgets/choroplethMap/constants/mapConstants';
import { LAYER_NAMES } from 'widgets/choroplethMap/constants/layerNames';
import useOutlineLayer from './useOutlineLayer';

export default function useChoroplethHooks() {
	useChoroplethSource();
	useOutlineLayer({
		sourceName: CHOROPLETH_COUNTRY_SOURCE,
		layerName: LAYER_NAMES.COUNTRY_OUTLINE_LAYER,
		sourceLayer: SOURCE_LAYERS.COUNTRIES,
		minzoom: 0,
		maxzoom: 4,
	});
	useOutlineLayer({
		sourceName: CHOROPLETH_STATE_SOURCE,
		layerName: LAYER_NAMES.STATE_OUTLINE_LAYER,
		sourceLayer: SOURCE_LAYERS.STATES,
		minzoom: 4,
		maxzoom: 22,
	});
	usePolygonLayer({
		sourceName: CHOROPLETH_COUNTRY_SOURCE,
		layerName: LAYER_NAMES.CHOROPLETH_COUNTRY_LAYER,
		sourceLayer: SOURCE_LAYERS.COUNTRIES,
		minzoom: 0,
		maxzoom: 4,
	});
	usePolygonLayer({
		sourceName: CHOROPLETH_STATE_SOURCE,
		layerName: LAYER_NAMES.CHOROPLETH_STATE_LAYER,
		sourceLayer: SOURCE_LAYERS.STATES,
		minzoom: 4,
		maxzoom: 22,
	});
	// usePolygonHover();
}
